import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon } from 'lucide-react';
const buyers = [['María G.', 'Córdoba'], ['Julián L.', 'Buenos Aires'], ['Sofía M.', 'Rosario'], ['Diego L.', 'Tucumán'], ['Ana C.', 'Mendoza'], ['Roberto F.', 'Santa Fe']];
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initial = window.setTimeout(() => setVisible(true), 6000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
        setVisible(true);
      }, 850);
    }, 30000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(cycle);
    };
  }, []);
  return <AnimatePresence data-id="element-80" data-mp="2fxg53lon9c58">{visible && <motion.aside initial={{
      opacity: 0,
      x: -20,
      y: 24
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      type: 'spring',
      stiffness: 360,
      damping: 28
    }} className="fixed bottom-4 left-4 z-50 max-w-[330px] border border-brand-gold/65 bg-brand-ink p-4 text-white shadow-2xl" aria-live="polite" data-id="element-81" data-mp="2fwol784et2us"><div className="flex gap-3" data-id="element-82" data-mp="1mx3y9d07ssit"><BadgeCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-gold" data-id="element-83" data-mp="1mvsu3c2uxir6" /><div data-id="element-84" data-mp="1hxiy4z9b6e4i"><p className="text-xs text-brand-goldLight" data-id="element-85" data-mp="1hxiwyvxko82x">Compra verificada · hace unos minutos</p><p className="mt-1 text-sm" data-id="element-86" data-mp="1d60wsa3dibj0"><strong data-id="element-87" data-mp="1d5hn1gnvmtg2">{buyer[0]}</strong> de {buyer[1]} obtuvo</p><p className="mt-1 text-sm font-bold text-brand-gold" data-id="element-88" data-mp="187fve7cdxlsz">Mega Pack Diabetes Holística™</p></div></div></motion.aside>}</AnimatePresence>;
}